import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { CandidatesPage } from "QuorumGrassroots/pages/campaign/candidates/CandidatesPage"

export const exploreCandidatesRoutes: RouteConfig[] = [
    {
        path: "/campaign/:id/candidates",
        component: CandidatesPage,
        requiresLogin: false,
        pageTitle: "Candidates",
        key: "campaign-candidates",
    },
]
